// eslint-disable-next-line react/jsx-curly-newline
import React from 'react';

const FAQEnglish = (props) => {
  return (
    <div>
      <h3>What is the AuctionACCESS annual membership fee?</h3>
      <p className="faq">
        The annual membership fee is ${props.amount} per individual in AuctionACCESS.
        Membership facilitates credentialing at over 320 auction marketplaces
        throughout the US and Canada.
      </p>
      <h3>How can I pay my membership?</h3>
      <p className="faq">
        Membership can be paid via credit card, debit card, or ACH by entering
        your information to the right. You can also log into your account at
        AuctionACCESS.com to renew multiple memberships if you are an owner or
        officer.
      </p>
      <p className="faq">
        For more information, please visit our <a href="https://www.auctionaccess.com/faq/">
          FAQ page</a>
      </p>
    </div>
  );
}

export default FAQEnglish;